import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const LibraryRoutes: RouteBundle = {
  domain: 'library',
  routes: [
    {
      urlPattern: 'library/listing',
      handler: EditorRoutes.libraryListing.bind(EditorRoutes),
    },
  ],
};
